// extracted by mini-css-extract-plugin
export var subnav = "DesktopMainNav-module--subnav--2fg2_";
export var light = "DesktopMainNav-module--light--2-x56";
export var visible = "DesktopMainNav-module--visible--nbR1h";
export var hasActiveSubnav = "DesktopMainNav-module--hasActiveSubnav--2XSPR";
export var subnavIsVisible = "DesktopMainNav-module--subnavIsVisible--3KFF_";